import React from 'react';
import '../styles/MessageBubble.css';

function MessageBubble({ role, content }) {
  return (
    <div className={`message-bubble ${role}`}>
      <div className="message-content">
        {content}
      </div>
    </div>
  );
}

export default MessageBubble;
